import React from 'react';
export function Manifesto() {
  return <section className="relative bg-paper py-[58px] md:py-[76px]" data-id="element-61">
      <div className="max-w-page mx-auto px-6" data-id="element-62">
        <div className="max-w-measure mx-auto" data-id="element-63">
          <p className="dropcap text-[clamp(1.15rem,1.9vw,1.34rem)] leading-[1.7] text-ink mb-[1.1em]" data-id="element-64">
            A <em className="italic" data-id="element-65">fermata</em> is the small mark in sheet
            music that tells you to hold a note longer than written — to pause.
            That is the whole idea behind everything we make. Modern life keeps
            your nervous system revved, and the fastest way down a gear usually
            isn't more thinking, more willpower, or one more app. It's a longer,
            slower breath out.
          </p>
          <p className="text-[clamp(1.15rem,1.9vw,1.34rem)] leading-[1.7] text-ink m-0" data-id="element-66">
            So that's what we build: simple, physical tools that help you take
            one long exhale and come back to yourself. We're not a meditation
            app, a supplement, or a miracle. We're a small company that believes
            calm is a body-state first — and that the tools for it should be
            honest, analog, and good enough to actually keep on you.
          </p>
        </div>
      </div>
    </section>;
}